"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const localized_strings_1 = __importDefault(require("localized-strings"));
const types_1 = require("../../types");
const locales = new localized_strings_1.default({
    en: {
        status: {
            [types_1.InvoiceType.Invoice]: {
                [types_1.InvoiceStatus.Canceled]: 'Canceled',
                [types_1.InvoiceStatus.MarkedAsPaid]: 'Paid',
                [types_1.InvoiceStatus.Overdue]: 'Overdue',
                [types_1.InvoiceStatus.Paid]: 'Paid',
                [types_1.InvoiceStatus.Pending]: 'Draft',
                [types_1.InvoiceStatus.Sent]: 'Sent',
            },
            [types_1.InvoiceType.Quote]: {
                [types_1.QuoteStatus.Accepted]: 'Accepted',
                [types_1.QuoteStatus.Archived]: 'Declined',
                [types_1.QuoteStatus.Pending]: 'Draft',
                [types_1.QuoteStatus.Sent]: 'Sent',
            },
        },
    },
    fr: {
        status: {
            [types_1.InvoiceType.Invoice]: {
                [types_1.InvoiceStatus.Canceled]: 'Annulée',
                [types_1.InvoiceStatus.MarkedAsPaid]: 'Payée',
                [types_1.InvoiceStatus.Overdue]: 'En retard',
                [types_1.InvoiceStatus.Paid]: 'Payée',
                [types_1.InvoiceStatus.Pending]: 'Brouillon',
                [types_1.InvoiceStatus.Sent]: 'Envoyée',
            },
            [types_1.InvoiceType.Quote]: {
                [types_1.QuoteStatus.Accepted]: 'Accepté',
                [types_1.QuoteStatus.Archived]: 'Refusé',
                [types_1.QuoteStatus.Pending]: 'Brouillon',
                [types_1.QuoteStatus.Sent]: 'Envoyé',
            },
        },
    },
});
exports.default = locales;
